import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

interface ParamsCTXRList {
  cloud?: string;
  region?: string;
}

export function getCTXRlistGlobal(
  subscriptionId: number,
  tenantId: number,
  token: string,
  cloud?: string,
  region?: string
) {
  const params: ParamsCTXRList = {};
  if (cloud !== undefined) params.cloud = cloud;
  if (region !== undefined) params.region = region;

  return axios.get(
    `${API_URL}/v1/ctxr/${subscriptionId}/listSelector?tenantId=${tenantId}`,
    {
      params,
      headers: { Authorization: `Bearer ${token}` },
    }
  );
}

/** 2) NUEVO: para GET /v1/ctxr/listneighbor/:ctxrId?tenantId=... */
export function getNeighborsListByCtxrId(
  token: string,
  ctxrId: string,
  tenantId: number
) {
  return axios.get(`${API_URL}/v1/ctxr/listneighbor/${ctxrId}?tenantId=${tenantId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/**
 * 2) GET /v1/ctxr/-1/statusneighbor?tenantId=...
 */
export function getNeighborsStatus(token: string, tenantId: number) {
  return axios.get(`${API_URL}/v1/ctxr/-1/statusneighbor?tenantId=${tenantId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/**
 * POST /v1/ctxr/bgpsumary/{ctxrId}?tenantId=1
 */
export function postBgpSummary(
  token: string,
  ctxrId: string,
  tenantId: number,
  payload: { neighbor: string; type: string },
  signal?: AbortSignal
) {
  return axios.post(
    `${API_URL}/v1/ctxr/bgpsumary/${ctxrId}?tenantId=${tenantId}`,
    payload,
    {
      headers: { Authorization: `Bearer ${token}` },
      signal,
    }
  );
}

/** Query params read by chopper-backend `getLogRecordsForCtxr`. */
interface GetLogsByCtxrIdParams {
  tenantId: number;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  logLevel?: string;
  searchTerm?: string;
}

export interface LogsTimeRange {
  start: Date;
  end: Date;
}

/**
 * The handler compares these against the zone-less OpenSearch `timestamp`,
 * which OpenSearch reads as UTC, so the range goes out in UTC (as Reflector
 * V2 Logs already does). Sending the picker's local wall-clock time shifted
 * the window by the browser's UTC offset.
 */
function toUtcDateAndTime(d: Date): { date: string; time: string } {
  const iso = d.toISOString();
  return { date: iso.slice(0, 10), time: iso.slice(11, 19) };
}

/**
 * GET /v1/ctxr/getLogRecordsForCtxr/{ctxrId}?tenantId=...&startDate=...&startTime=...&endDate=...&endTime=...&[logLevel=...]&[searchTerm=...]
 *
 * CTX-1073: this used to send the old names (`fecha`, `fechastart`, `level`,
 * `search`…), which the handler ignores, so every call returned the newest 300
 * lines regardless of the range, level or search chosen.
 */
export function getLogsByCtxrId(
  token: string,
  ctxrId: string,
  tenantId: number,
  range: LogsTimeRange,
  level?: string,
  search?: string
) {
  const start = toUtcDateAndTime(range.start);
  const end = toUtcDateAndTime(range.end);
  const params: GetLogsByCtxrIdParams = {
    tenantId,
    startDate: start.date,
    startTime: start.time,
    endDate: end.date,
    endTime: end.time,
  };
  if (level) {
    params.logLevel = level;
  }
  if (search) {
    params.searchTerm = search;
  }

  return axios.get(`${API_URL}/v1/ctxr/getLogRecordsForCtxr/${ctxrId}`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
}
